var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('h1',[_vm._v("Integrations")]),_c('ResponsiveTable',{attrs:{"headers":['LTI Platforms', ''],"rows":_vm.platforms}}),_c('BaseButton',{attrs:{"type":"submit","href":{name: 'AdminIntegrationsAddPlatform'}}},[_vm._v(" Add platform ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }